module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_8019.7b2cab02.png";